<template>
  <div>
    <div class="h-screen flex  bg-gray-100">
      <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->

      <!-- Static sidebar for desktop -->
      <div class="hidden md:flex md:flex-shrink-0">
        <div class="flex flex-col w-64">
          <!-- Sidebar component, swap this element with another sidebar if you like -->
          <div
            class="flex flex-col h-0 flex-1 border-r border-gray-200 bg-white"
          >
            <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
              <nav class="mt-5 flex-1 px-2 bg-white space-y-1">
                <!-- Current: "bg-gray-100 text-gray-900", Default: "text-gray-600 hover:bg-gray-50 hover:text-gray-900" -->
                <router-link
                  :to="{ name: 'LooxSettings' }"
                  exact-active-class="bg-gray-100 text-gray-900"
                  class=" text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
                >
                  Settings
                </router-link>
                <router-link
                  :to="{ name: 'LooxScheduled' }"
                  exact-active-class="bg-gray-100 text-gray-900"
                  class=" text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
                >
                  Scheduled
                </router-link>

                <router-link
                  :to="{ name: 'LooxMessageLogs' }"
                  exact-active-class="bg-gray-100 text-gray-900"
                  class=" text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
                >
                  MessageLogs
                </router-link>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  beforeCreate() {
    const store = this.$store.getters.getStore;
    if (store.plan === "free" || store.plan === "limited_free") {
      alert("please upgrade to paid plans for integrations");
      this.$router.push({ name: "Integrations" });
      return;
    }
  }
};
</script>

<style lang="scss" scoped></style>
